import uk from './uk.json';

type Texts = typeof uk;
/** A key of a single text, not of a list. */
export type TextKey = { [K in keyof Texts]: Texts[K] extends string ? K : never }[keyof Texts];
/** A key of a list of pairs, like the controls. */
export type ListKey = { [K in keyof Texts]: Texts[K] extends string ? never : K }[keyof Texts];

/** Whether a key from a card names one of the texts. */
export function isTextKey(key: string): key is TextKey {
  return typeof (uk as Record<string, unknown>)[key] === 'string';
}

/** A text for the player, with {0}, {1}… filled in. */
export function t(key: TextKey, ...values: (string | number)[]): string {
  return uk[key].replace(/\{(\d+)\}/g, (_, i: string) => String(values[Number(i)]));
}

/** A list of pairs for the player, such as a key and what it does. */
export function pairs(key: ListKey): readonly (readonly [string, string])[] {
  return uk[key].map(([a, b]) => [a, b] as const);
}
